import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/**
 * Get SEO Page Data by Slug
 */
export const getSeoPageBySlug = createAsyncThunk(
  "seoPage/getBySlug",
  async ({ slug }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/seopage/get_by_url`,
        { slug },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const seoPageSlice = createSlice({
  name: "seoPage",
  initialState: {
    loading: false,
    seoPageData: null,
    error: null,
  },
  reducers: {
    resetSeoPageState: (state) => {
      state.loading = false;
      state.seoPageData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSeoPageBySlug.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSeoPageBySlug.fulfilled, (state, action) => {
        state.loading = false;
        state.seoPageData = action.payload;
      })
      .addCase(getSeoPageBySlug.rejected, (state, action) => {
        state.loading = false;
        state.seoPageData = null;
        state.error = action.payload;
      });
  },
});

export const { resetSeoPageState } = seoPageSlice.actions;
export default seoPageSlice.reducer;
